/**
 * Rounds an input value to a string with a maximum of two decimal places
 * @param inputValue initial value as either string or number
 * @returns string with a rounded number to max two decimal places (less if the last digits are zeroes)
 */
export const truncateToTwoDecimalPlaces = (inputValue: number | string) =>
  (Math.round(+inputValue * 100) / 100).toString();

/**
 * Rounds an input value to a string with a maximum of two decimal places
 * @param inputValue initial value as either string or number
 * @returns string with a rounded number to max two decimal places (less if the last digits are zeroes)
 */
export const truncateToWholeNumber = (inputValue: number | string) =>
  Math.round(+inputValue).toString();
